import http from "../plugins/axios";
const BASE_URI = "/advice";
export default {
  getAdvicesByDegreeType({ degreeType }) {
    return http.get(`${BASE_URI}?all=1&degreeType=${degreeType}`);
  },
  create(data) {
    return http.post(`${BASE_URI}`, data);
  },
};
